<template>
    <b-modal ref="mdlNuovaVoce" size="lg" :title="titoloModal" @hidden="onCloseModal" @ok="onClickOk" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <div>
            <b-card class="sa-card" header="Dettaglio" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Sezione:</label>
                        <b-form-select v-model="jsonData.sezioneDizionario" :options="sezioneOptions" :value="null" value-field="value" text-field="text" @change="onChangeSezione"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Tipo:</label>
                        <b-form-select v-model="jsonData.tipo" :options="typeOptions" :value="null" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Codice:</label>
                        <b-form-input v-model="jsonData.codiceTipo" placeholder="Codice"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Descrizione:</label>
                        <b-form-input v-model="jsonData.descrizioneTipo" placeholder="Descrizione"></b-form-input>
                    </b-col>
                </b-row>
                <b-row v-if="jsonData.sezioneDizionario === 'DOCUMENTO' || jsonData.sezioneDizionario === 'DOCUMENTOMOBILE'">
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Tipo Movimento:</label>
                        <b-form-select v-model="jsonData.tipoMovimento" :options="tipoMovimentiOptions" :value="null" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Documento Richiesto:</label>
                        <b-form-select v-model="jsonData.richiedeFattura" :options="tipoDocumentoOptions" :value="null" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                </b-row>
            </b-card>
            <modal-error ref="cmpModalError"></modal-error>
        </div>
    </b-modal>
</template>

<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";
// import DatePicker from "vue2-datepicker";
export default {
    components: { ModalError },
    mixins: [UtilityMixin],
    // components: { DatePicker },
    data() {
        return {
            isNew: true,
            isReadonly: false,
            isRequired: false,
            pathResource: "/dizionariotipi",
            pathResourceSezioneDizionario: "/dizionariosezioni",
            titoloModal: "",
            sezioneOptions: [{ value: "", text: "-Seleziona Valore-" }],
            tipoMovimentiOptions: [
                { value: null, text: "-Seleziona Valore-" },
                { value: "C", text: "CARICO" },
                { value: "S", text: "SCARICO" },
                { value: "I", text: "INVARIATO" },
            ],
            typeOptions: [
                { value: null, text: "-Seleziona Valore-" },
                { value: "P", text: "PRINCIPALE" },
                { value: "A", text: "ARCHIVIO" },
            ],
            tipoDocumentoOptions: [{ value: null, text: "-Seleziona Valore-" }],
            jsonData: { sezioneDizionario: null, codiceTipo: null, descrizioneTipo: null, richiedeFattura: null, tipoMovimento: null, tipo: null, path: null },
        };
    },
    methods: {
        onChangeSezione() {
            let me = this;
            if (me.jsonData.sezioneDizionario === "ANAGRAFICA") {
                me.jsonData.path = "papercleananagraficatipi/anagrafica";
            } else if (me.jsonData.sezioneDizionario === "DOCUMENTO") {
                me.jsonData.path = "papercleandocumentotipi/documenti";
            } else if (me.jsonData.sezioneDizionario === "DOCUMENTOMOBILE") {
                me.jsonData.path = "papercleandocumentotipi/documentimobile";
            } else {
                me.jsonData.path = null;
            }
            console.log(me.jsonData.path);
        },
        openModal(item) {
            let me = this;
            me.$emit("beforloadData");
            if (item !== null) {
                me.titoloModal = "Modifica Voce Dizionario";
                me.jsonData = item;
            } else {
                me.titoloModal = "Aggiungi Voce Dizionario";
                me.jsonData = { sezioneDizionario: null, codiceTipo: null, descrizioneTipo: null, richiedeFattura: null, tipoMovimento: null, tipo: null, path: null };
            }
            me.loadSezioni();
            me.loadSezloadTipiDocumento();
            me.$refs.mdlNuovaVoce.show();
            me.$emit("afterLoadData");
        },
        loadSezioni() {
            let me = this;
            let filtro = {};
            UtilityMixin.methods.loadDataResources(me.pathResourceSezioneDizionario, filtro, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            (me.sezioneOptions = []),
                response.data.data.list.forEach((element) => {
                    me.sezioneOptions.push({ value: element.sezione, text: element.sezione });
                });
            me.sezioneOptions.unshift({ value: null, text: "-Seleziona Valore-" });
        },
        loadDataError(response) {
            console.log(response);
        },
        onCloseModal() {
            let me = this;
            me.$emit("beforloadData");
            me.jsonData = { sezioneDizionario: null, codiceTipo: null, descrizioneTipo: null, richiedeFattura: null, tipoMovimento: null, tipo: null, path: null };
            me.$emit("afterLoadData");
        },
        loadSezloadTipiDocumento() {
            let me = this;
            let filtro = { sezioneDizionario: "DOCUMENTO" };
            UtilityMixin.methods.loadDataResources(me.pathResource, filtro, me.loadSezloadTipiDocumentoSuccess, me.loadSezloadTipiDocumentoError);
        },
        loadSezloadTipiDocumentoSuccess(response) {
            let me = this;
            (me.tipoDocumentoOptions = []),
                response.data.data.list.forEach((element) => {
                    me.tipoDocumentoOptions.push({ value: element.codice, text: element.descrizioneTipo });
                });
            me.tipoDocumentoOptions.unshift({ value: null, text: "-Seleziona Valore-" });
        },
        loadSezloadTipiDocumentoError(response) {
            console.log(response);
        },
        onClickOk(bvModalEvent) {
            let me = this;
            me.$emit("beforloadData");
            bvModalEvent.preventDefault();
            // console.log(me.jsonData);
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, this.saveSuccessResponse, this.saveErrorResponse);
        },
        saveSuccessResponse(response) {
            let me = this;
            me.$emit("afterSaveSuccess", response);
            me.$emit("afterLoadData");
            me.$refs.mdlNuovaVoce.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },

        saveErrorResponse(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
            this.$emit("afterLoadData");
        },
    },
};
</script>
